<template>
    <div id="redemption">
        <img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/rice-day-2021/section-one-banner.jpg">
        <div class="container-fluid">
            <div class="row" style="margin-bottom: 0; margin-top: -6px;">
                <div class="col s12 product-tab-cont">
                    <div class="row" style="margin-bottom: 0">
                        <div class="col s12 m2 hide-on-small-and-down">
                            <img class="responsive-img tefal-logo" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/rice-day-2021/tefal_logo.png">
                        </div>
                        <div class="col s12 m8 scrollable-col">
                            <ul class="menubar">
                                <li><a href="#every">EVERY GRAIN MAKES A DIFFERENCE</a></li>
                                <li><a href="#free">FREE RICE CONTAINER</a></li>
                                <li><a href="#spec">SPECIFICATION</a></li>
                            </ul>
                        </div>
                        <a href="#" v-on:click="productModal('https://www.lazada.com.my/tefal/?q=All-Products&shop_category_ids=990204&from=wangpu&sc=KVUG', 'https://shopee.com.my/shop/84645381/search?page=0&shopCollection=137244260')" class="col s12 m2 buy-now-btn-col center-align">
                            Buy Now
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid" id="every" style="position: relative">
            <div class="row" style="margin-bottom: 0;">
                <div class="col s12" style="padding: 0">
                    <img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/rice-day-2021/section-two.jpg">
                    <div class="col s12" style="position: absolute; top: 20%;">
                        <div class="row">
                            <div class="col s12">
                                <img class="responsive-img title-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/rice-day-2021/title.png">
                            </div>
                            <div class="col s12 step-col">
                                <div class="row">
                                    <div class="col s6 step-inner-col" style="border-right: 1px solid #fff;">
                                        <img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/rice-day-2021/step_1.png">
                                        <div class="description">Purchase any Tefal Rice Cooker during the campaign period and register for <span><a :href="warrantyUrl">e-Warranty</a></span> at our website</div>
                                    </div>
                                    <div class="col s6 step-inner-col">
                                        <img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/rice-day-2021/step_2.png">
                                        <div class="description">1kg of rice will be donated to those in need with every rice cooker sold</div>
                                    </div>
                                    <div class="col s12 center-align">
                                        <div class="description">*T&C APPLY</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid" id="free">
            <div class="row" style="margin-bottom: 0;">
                <div class="col s12" style="padding: 0; margin-top: -5px;">
                    <img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/rice-day-2021/section-three.jpg">
                </div>
            </div>
        </div>

        <div class="container-fluid" id="spec" style="position: relative">
            <div class="row" style="margin-bottom: 0;">
                <div class="col s12" style="padding: 0; margin-top: -5px;">
                    <img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/rice-day-2021/spec-bg.jpg">
                </div>
            </div>
        </div>

        <div class="container-fluid" style="background-color: #1b1a18; margin-top: -7px;">
            <div class="container spec-container">
               <div class="row spec-row">
                   <div class="col-12">
                       <table class="spec">
                           <thead>
                           <tr style="border-bottom: none">
                               <th></th>
                               <th><img class="responsive-img product-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/rice-day-2021/RK820D.png"></th>
                               <th><img class="responsive-img product-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/rice-day-2021/RK8608.png"></th>
                               <th><img class="responsive-img product-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/rice-day-2021/RK7621.png"></th>
                               <th><img class="responsive-img product-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/rice-day-2021/RK808A.png"></th>
                           </tr>
                           </thead>
                           <tbody>
                           <tr style="border-bottom: none">
                               <td style="width: 20%;"></td>
                               <td><div class="product-name-btn"><a target="_blank" href="https://product.tefal.com.my/rk820d">STEAM PRO IH <br> Rice Cooker (RK820D)</a></div></td>
                               <td><div class="product-name-btn"><a target="_blank" href="https://product.tefal.com.my/healthy-rice-cooker">HEALTHY & TASTY <br> Rice Cooker (RK8608)</a></div></td>
                               <td><div class="product-name-btn"><a target="_blank" href="https://product.tefal.com.my/rice-xpress-ih">RICE XPRESS IH <br> Rice Cooker (RK7621)</a></div></td>
                               <td><div class="product-name-btn"><a target="_blank" href="https://product.tefal.com.my/rk808">DELIRICE PRO <br> Rice Cooker (RK808A)</a></div></td>
                           </tr>
                           <tr>
                               <td>Technology</td>
                               <td>Induction Heating</td>
                               <td>Induction Heating</td>
                               <td>Induction Heating</td>
                               <td>Induction Heating</td>
                           </tr>
                           <tr>
                               <td>Power</td>
                               <td>1660W</td>
                               <td>800W</td>
                               <td>1200W</td>
                               <td>1200W</td>
                           </tr>
                           <tr>
                               <td>Capacity</td>
                               <td>1.8L/ 10 Cup</td>
                               <td>1.0L/ 5 Cup</td>
                               <td>1.5L/ 8 Cup</td>
                               <td>1.5L/ 8 Cup</td>
                           </tr>
                           <tr>
                               <td>Spherical Pot</td>
                               <td>Yes</td>
                               <td>Yes</td>
                               <td>Yes</td>
                               <td>Yes</td>
                           </tr>
                           <tr>
                               <td>Inner Pot Coating</td>
                               <td>Non - Stick</td>
                               <td>Non - Stick</td>
                               <td>Non - Stick</td>
                               <td>Non - Stick</td>
                           </tr>
                           <tr>
                               <td>Pot Thickness</td>
                               <td>3.0 mm | 6 Layers</td>
                               <td>3.0 mm | 6 Layers</td>
                               <td>3.0 mm | 6 Layers</td>
                               <td>3.0 mm | 5 Layers</td>
                           </tr>
                           <tr>
                               <td>Removable Inner Lid</td>
                               <td>Yes</td>
                               <td>Yes</td>
                               <td>Yes</td>
                               <td>Yes</td>
                           </tr>
                           <tr>
                               <td>Cooking programs</td>
                               <td>36</td>
                               <td>10</td>
                               <td>12</td>
                               <td>16</td>
                           </tr>
                           <tr>
                               <td>Keep Warm</td>
                               <td>Automatic | Up to 24 Hours</td>
                               <td>Automatic | Up to 24 Hours</td>
                               <td>Automatic | Up to 12 Hours</td>
                               <td>Automatic | Up to 12 Hours</td>
                           </tr>
                           <tr>
                               <td>Delayed Start</td>
                               <td>Up to 24 Hours</td>
                               <td>Up to 24 Hours</td>
                               <td>Up to 24 Hours</td>
                               <td>Up to 24 Hours</td>
                           </tr>
                           <tr>
                               <td>Steam Basket</td>
                               <td>Yes</td>
                               <td>Yes</td>
                               <td>Yes</td>
                               <td>Yes</td>
                           </tr>
                           <tr style="border-bottom: none">
                               <td></td>
                               <td>
                                   <div class="rrp">RRP:</div>
                                   <div class="price">RM1499</div>
                                   <img style="cursor: pointer" v-on:click="productModal('https://www.lazada.com.my/products/tefal-rice-cooker-pro-ih-steam-18l-rk820d-i465330744-s749584006.html', 'https://shopee.com.my/Tefal-Rice-Cooker-Pro-IH-Steam-10-Cups-(RK820D65)-i.84645381.1941213138')" class="responsive-img buy-now-btn" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/rice-day-2021/buy_now.png">
                               </td>
                               <td>
                                   <div class="rrp">RRP:</div>
                                   <div class="price">RM1299</div>
                                   <img style="cursor: pointer" v-on:click="productModal('https://www.lazada.com.my/products/tefal-healthy-rice-cooker-rk8608-i470972542-s767122232.html', 'https://shopee.com.my/Tefal-IH-Low-GI-Healthy-Rice-Cooker-RK8608-i.84645381.7511078789')" class="responsive-img buy-now-btn" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/rice-day-2021/buy_now.png">
                               </td>
                               <td>
                                   <div class="rrp">RRP:</div>
                                   <div class="price">RM899</div>
                                   <img style="cursor: pointer" v-on:click="productModal('https://www.lazada.com.my/products/tefal-rice-xpress-ih-rice-cooker-rk7621-i1407478178-s4479312539.html', 'https://shopee.com.my/Tefal-Rice-Xpress-IH-Rice-Cooker-RK7621-i.84645381.4150459314')" class="responsive-img buy-now-btn" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/rice-day-2021/buy_now.png">
                               </td>
                               <td>
                                   <div class="rrp">RRP:</div>
                                   <div class="price">RM799</div>
                                   <img style="cursor: pointer" v-on:click="productModal('https://www.lazada.com.my/products/tefal-induction-ih-rice-cooker-15l-rk808a-i584340234-s1173664881.html', 'https://shopee.com.my/Tefal-Induction-Rice-Cooker-(1.5L)-RK808-i.84645381.2911376751')" class="responsive-img buy-now-btn" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/rice-day-2021/buy_now.png">
                               </td>
                           </tr>
                           </tbody>
                       </table>
                   </div>
               </div>
            </div>
        </div>
        <div id="buy-now-modal" class="modal shop-modal">
            <a href="#!" class="modal-close" style="position: absolute; top: 2%; right: 2%;" v-on:click="modalClose()"><i class="material-icons close-btn">close</i></a>
            <div class="row">
                <div class="col s12" style="margin-top: 10%;">
                    <div class="row">
                        <div class="col s12 m6">
                            <img class="responsive-img trolley-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/buy-now-modal/trolley.png">
                        </div>
                        <div class="col s12 m6 modal-col">
                            <h1 class="modal-title">WHERE TO BUY</h1>
                            <div class="modal-subtitle">Offline Retailer</div>
                            <a target="_blank" href="https://www.tefal.com.my/where-to-buy-on-line">
                                <img class="responsive-img retailer-btn" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/buy-now-modal/retailer-btn.png">
                            </a>
                            <div class="modal-subtitle">Online Retailer</div>
                            <div class="row">
                                <div class="col s12 modal-shop-col">
                                    <div class="row">
                                        <div class="col s4">
                                            <a target="_blank" :href="lazada">
                                                <img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/buy-now-modal/lazada-shop.png">
                                            </a>
                                        </div>
                                        <div class="col s4">
                                            <a target="_blank" :href="shopee">
                                                <img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/buy-now-modal/shopee-shop.png">
                                            </a>
                                        </div>
                                        <div class="col s4">
                                            <a target="_blank" href="https://www.tefal.com.my/where-to-buy-on-line">
                                                <img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/buy-now-modal/other-shop.png">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RiceDayComponent",
    props: [
        'siteUrl',
        'warrantyUrl'
    ],
    data () {
        return {
            lazada: 'https://www.lazada.com.my/shop/tefal',
            shopee: 'https://shopee.com.my/tefal_os'
        }
    },
    created() {
        $(document).ready(function() {
            $('#buy-now-modal').modal();
        })
    },
    mounted() {
        $(document).on('scroll', function() {

            if ($(this).scrollTop() >= $('#every').position().top) {
                $('.product-tab-cont').addClass('sticky');
            }
            else {
                $('.product-tab-cont').removeClass('sticky');
            }
        });


    },
    methods: {
        productModal(lazada, shopee) {
            $('body').css('overflow', 'auto');
            $('#buy-now-modal').modal('open');

            this.lazada = lazada;
            this.shopee = shopee;
        },
        modalClose () {
            $('body').css('overflow', 'auto');
        }
    }
}
</script>

<style scoped>

</style>
